import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { monthName } from "../lib/api";

const LABELS = {
  abonado: "ABONADO",
  parcial: "PAGO PARCIAL",
  pendiente: "PENDIENTE",
  no_aplica: "—",
};

const STYLES = {
  abonado: "bg-logo-light text-logo-text",
  parcial: "bg-amber-100 text-amber-900",
  pendiente: "bg-red-50 text-red-700",
  no_aplica: "bg-muted text-ink-700",
};

export const PayState = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-block rounded-full px-3 py-1 text-sm font-semibold ${STYLES[status]}`}>
    {LABELS[status]}
  </span>
);

/** Tabla de cuotas mes a mes con importe, abonado, pendiente, estado y deuda total. */
export const FeesTable = ({ rows, totalDebt, testid, note, onSetPaid }) => (
  <div data-testid={testid}>
    <div className="-mx-2 overflow-x-auto">
      <table className="w-full min-w-[560px] text-left text-base">
        <thead>
          <tr className="border-b border-border text-ink-700">
            <th className="py-2 pr-3">Mes</th>
            <th className="py-2 pr-3">Importe</th>
            <th className="py-2 pr-3">Abonado</th>
            <th className="py-2 pr-3">Pendiente</th>
            <th className="py-2 pr-3">Estado</th>
            {onSetPaid && <th className="py-2">Registrar abono</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.month} data-testid={`fee-row-${r.month}`}
              className={`border-b border-border ${r.current ? "bg-cream" : ""}`}>
              <td className="py-2 pr-3">
                {monthName(r.month)}
                {r.paused && <span className="ml-2 text-sm text-ink-700">(en pausa)</span>}
                {r.discount && (
                  <span className="ml-2 text-sm text-logo-text" data-testid={`fee-discount-${r.month}`}>
                    (30 % de descuento)
                  </span>
                )}
              </td>
              <td className="py-2 pr-3">
                {r.amount.toFixed(2)} €
                {r.discount && r.base_amount > r.amount && (
                  <span className="ml-1 text-sm text-ink-700 line-through">
                    {r.base_amount.toFixed(2)} €
                  </span>
                )}
              </td>
              <td className="py-2 pr-3">{r.paid.toFixed(2)} €</td>
              <td className="py-2 pr-3" data-testid={`fee-pending-${r.month}`}>{r.pending.toFixed(2)} €</td>
              <td className="py-2 pr-3"><PayState status={r.status} testid={`fee-state-${r.month}`} /></td>
              {onSetPaid && (
                <td className="py-2">
                  <PaidInput month={r.month} value={r.paid} onSave={onSetPaid} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="mt-4 rounded-xl bg-cream p-4 text-lg" data-testid={`${testid}-total-debt`}>
      <strong>Deuda total: {totalDebt.toFixed(2)} €</strong>
    </p>
    {note && <p className="mt-3 text-base text-ink-700">{note}</p>}
  </div>
);

const PaidInput = ({ month, value, onSave }) => {
  const id = `paid-${month}`;
  return (
    <form className="flex gap-2" onSubmit={(e) => {
      e.preventDefault();
      onSave(month, Number(e.target.elements[id].value));
    }}>
      <Input name={id} data-testid={`paid-input-${month}`} type="number" step="0.01" min="0"
        defaultValue={value} className="h-11 w-24 text-base" />
      <Button data-testid={`paid-save-${month}`} variant="outline" className="h-11 text-base">
        Guardar
      </Button>
    </form>
  );
};
